import type { IconName } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { enumPictureType, enumSubChartFlag } from "@coreapp/constants";
import type { QChartBox } from "@coreapp/CoreApp/QChartBox";
import type { QSvrChartMgr } from "@coreapp/CoreApp/QSvrChartMgr";
import type { GetDoc } from "@/Utils/StateLib";

type ChartDoc = NonNullable<ReturnType<typeof GetDoc>>;

export type ReadOnlyBoxOption = {
  label: string;
  dataTestId: string;
  value: "maketop" | "reloadpic";
  icon: IconName;
  clickHandler: () => void;
  divider?: boolean;
};

export type GetReadOnlyBoxOptionsParams = {
  doc: ChartDoc;
  targetBox: QChartBox;
  onCommand: (cmd: string) => () => void;
};

function canMakeTop(doc: ChartDoc, targetBox: QChartBox): boolean {
  const dataObj = targetBox.GetDataObj();
  const svrChartMgr = Globals._svrChartMgr as QSvrChartMgr | null;
  if (!doc.IsServerChart() || !dataObj || !svrChartMgr) return false;

  return (
    (dataObj.SmartGetFieldValue("Subordinates") as number) > 0 &&
    dataObj.GetObjectRecordID() !== svrChartMgr.GetTargetBoxID() &&
    targetBox.GetSubChartFlag() !== enumSubChartFlag.drillup &&
    !dataObj.IsRoot()
  );
}

function hasFieldPicture(targetBox: QChartBox): boolean {
  const cells: { GetPictureType: () => number }[] = targetBox.GetLayout()?.fCellList ?? [];
  return cells.some(cell => cell.GetPictureType() === enumPictureType.fieldPicture);
}

export function getReadOnlyBoxOptions({
  doc,
  targetBox,
  onCommand
}: GetReadOnlyBoxOptionsParams): ReadOnlyBoxOption[] {
  const options: ReadOnlyBoxOption[] = [];

  if (canMakeTop(doc, targetBox)) {
    options.push({
      label: appstr("maketop"),
      dataTestId: "ctx-menu-maketop",
      value: "maketop",
      icon: "caret-up",
      clickHandler: onCommand("maketop")
    });
  }

  if (hasFieldPicture(targetBox)) {
    options.push({
      label: appstr("reloadpic"),
      dataTestId: "ctx-menu-reload-image",
      value: "reloadpic",
      icon: "arrows-rotate",
      clickHandler: onCommand("reloadpic")
    });
  }

  return options;
}
